import React, { useEffect, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'
import { Box } from '@mui/material'

import { usePermissions } from '../../../../core/hooks'
import { ThemeButton, FilterBox } from '../../../../ui'
import { useCombos } from '../../../combos/hooks/combos.hook'
import { APPS_FILTERS } from '../../constants'
import { useTariffsDialogs } from '../../hooks/useTariffsDialogs'
import { useComunidades } from '../../hooks/useLoadComunidades'
import { tariffsFilterStyles } from './tariffs-filter.styles'

export const TariffsFilter = withStyles(tariffsFilterStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const ccaa = new URLSearchParams(location.search).get('ccaa')

  const combos = useSelector((state) => state.combos)
  const global = useSelector((state) => state.global)
  const { isPrescriptor } = usePermissions()

  const { comunidades, isLoading: isLoadingComunidades, loadComunidades } = useComunidades()

  useCombos(['cod_zona_zeus', 'provincias'])

  const { showAddTarifaDialog } = useTariffsDialogs()
  const navigateCreateTariff = () => navigate('/tariffs/new')

  useEffect(() => {
    const empresaId = global.empresa?.id
    if (empresaId) loadComunidades(empresaId)
  }, [global.empresa?.id, loadComunidades])

  const comunidadesNames = comunidades.filter((c) => c.activa).map((c) => c.nombre)

  const handleOpenAddTarifa = useCallback(() => {
    showAddTarifaDialog({
      comunidades: comunidadesNames,
      onAccept: comunidadesNames.length > 0 ? navigateCreateTariff : () => navigate(-1),
      //TODO: change history.goBack() to navigate method
    })
  }, [comunidadesNames, navigateCreateTariff, showAddTarifaDialog, navigate])

  const dataFilters = APPS_FILTERS.map((item) => {
    const it = { ...item }
    if (it.comboId) {
      it.values = combos[it.comboId]?.data
      if (it.comboId === 'provincias' && it.values && ccaa) {
        it.values = it.values.filter((p) => ccaa.split(',').includes(p.ca))
      }
    }
    return {
      ...it,
      label: formatMessage({
        id: `pages.tariffs.filters.${it.name}.title`,
      }),
    }
  })

  return (
    <FilterBox filters={dataFilters}>
      {isPrescriptor && (
        <Box display="flex" flexGrow={1} justifyContent="flex-end">
          <Box ml={2}>
            <ThemeButton
              color="primary"
              labelM="sm"
              onClick={handleOpenAddTarifa}
              disabled={isLoadingComunidades}
            >
              {formatMessage({ id: 'pages.tariffs.addButton.label' })}
            </ThemeButton>
          </Box>
        </Box>
      )}
    </FilterBox>
  )
})
